class EventNav {
  constructor(element) {
    this.element = element;
    this.toggleButton = this.element.querySelector('[aria-controls="event-subnav-items-mob"]');
    this.subnavList = this.element.querySelector('#event-subnav-items-mob');

    if (!this.toggleButton || !this.subnavList) return;

    this.setupDropdown();
  }

  setupDropdown() {
    this.toggleButton.addEventListener('click', () => {
      const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    const links = this.subnavList.querySelectorAll('.sub-link');
    links.forEach(link => {
      link.addEventListener('click', () => {
        this.closeMenu();
      });
    });
  }

  openMenu() {
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.subnavList.classList.add('is-open');
    this.subnavList.setAttribute('aria-hidden', 'false');
  }

  closeMenu() {
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.subnavList.classList.remove('is-open');
    this.subnavList.setAttribute('aria-hidden', 'true');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const block = document.querySelector('.event-subnav');
  if (block) new EventNav(block);
});

export default EventNav;
